export const useBaseUrl = () => {
  return useState<any>("baseUrl", () => {
    return useRuntimeConfig().public.API_BASE_URL as string;
  });
};
